import { ColoursObj, TEventrIcons } from "@eventr/common-storybook";
import { Box, Stack } from "@mui/material";
import { useMemo } from "react";
import { useFormatValue } from "../../hooks/useFormatValue";
import { CardText } from "../subComponents/cardText";
import { ColouredIcon } from "../subComponents/colouredIcon";
import { DisplayLabel } from "../subComponents/displayLabel";
import { TodoRange } from "../todoCard";
import { useObjectContext } from "../providers/objectProvider";
interface ITodoHeaderProps {
  todoName?: string;
  dueDate?: string;
  icon?: { image?: string; colour?: string };
  range?: TodoRange;
}
export const TodoHeader = ({ todoName, dueDate, icon, range }: ITodoHeaderProps) => {
  const { formatValue } = useFormatValue();
  const { visibility } = useObjectContext();

  const label = useMemo(() => {
    return dueDate ? "Due " + formatValue(dueDate, "date") : "";
  }, [dueDate, formatValue]);
  return (
    <Stack
      direction="row"
      sx={{
        gap: "8px",
        justifyContent: "space-between"
      }}>
      <Stack direction="row" sx={{
        gap: "8px"
      }}>
        <ColouredIcon name={(icon?.image as TEventrIcons) || "ToDo"} iconColour={icon?.colour} />
        <CardText color={range === "done" ? ColoursObj.shades.shade2 : ColoursObj.font.primary} variant="bodyBold">
          {todoName}
        </CardText>
      </Stack>

      <Box
        sx={{
          display: "flex",
          gap: "8px",
          alignItems: "center"
        }}>
        {visibility === "Private" && <ColouredIcon height="16px" name="Private" />}
        {range !== "done" && (
          <DisplayLabel
            textProps={{
              sx: { flexShrink: 0, whiteSpace: "nowrap" },
            }}
            label={label}
            labelTime={dueDate}
          />
        )}
      </Box>
    </Stack>
  );
};
